import React, { use, useEffect, useRef, useState } from "react";

import "./customAudioPlayer.css";
import PlayIcon from "../../assets/icons/playIcon";
import PauseIcon from "../../assets/icons/pausIcon";

interface CustomAudioPlayerProps {
    src: string;
}

export default function CustomAudioPlayer(props: CustomAudioPlayerProps) {

    useEffect(() => {
        calculateWaveform();
    }, []);

    useEffect(() => {
        createAudio();
    }, [props.src]);

    const [playing, setPlaying] = useState(false);
    const [time, setTime] = useState<string>("00:00");
    const audio = useRef<HTMLAudioElement | undefined>(undefined);
    const waveformRef = useRef<HTMLCanvasElement | null>(null);

    async function downloadAudio(): Promise<Blob | undefined> {
        try {
            const response = await fetch(props.src, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/audio',
                },
            });
            const blob = await response.blob();
            return blob;
        } catch (error) {
            console.error("Failed to download audio:", error);
            return undefined;
        }
    }


    async function calculateWaveform() {
        var audioFile = await downloadAudio();
        if(!audioFile) return;
        if(!waveformRef.current) return;

        let margin = 10,
        chunkSize = 30000;
        var audioContext = new AudioContext();
        let buffer = await audioFile.arrayBuffer(),
                audioBuffer = await audioContext.decodeAudioData(buffer),
                float32Array = audioBuffer.getChannelData(0);let array = [], i = 0, length = float32Array.length;while (i < length) {
            array.push(
                float32Array.slice(i, i += chunkSize).reduce(function (total, value) {
                    return Math.max(total, Math.abs(value));
                })
            );
        }
        drawWaveform(array, audioBuffer.duration);

        var time = audioBuffer.duration - (audio.current?.currentTime ?? 0); // get duration(float) in second
        var minute = Math.floor(time / 60); // get minute(integer) from time
        var tmp = Math.round(time - (minute * 60)); // get second(integer) from time
        var second = (tmp < 10 ? '0' : '') + tmp; // make two-figured integer if less than 10

        setTime(String(minute + ':' + second));

    }

    function drawWaveform(array: any, duration: number) {
        if (!waveformRef.current) return;
        const height = 150;
        const width = waveformRef.current.offsetWidth - 20;
        const ctx = waveformRef.current.getContext("2d");
        if(!ctx) {
            console.log("Error drawing waveform");
            return;
        }
        ctx.clearRect(0, 0, waveformRef.current.width, waveformRef.current.height);
        ctx.fillStyle = "#D33843";
        const totalElementWidthWithMargin = width / array.length;
        for(var i = 0; i < array.length; i++) {
            const timePos = i * (duration / array.length);
            const currentTime = audio.current?.currentTime ?? 0;
            if (timePos > currentTime) {
                ctx.fillStyle = "#383633";
            }
            ctx.fillRect(i * totalElementWidthWithMargin, height / 2 - array[i] * height / 2, 1.5, array[i] * height);
            
        }
        waveformRef.current.addEventListener("click", clickCanvas, false);

    }



    interface ClickCanvasEvent extends React.MouseEvent<HTMLCanvasElement> {
        clientX: number;
        clientY: number;
    }

    interface SampleRect {
        x: number;
        y: number;
        width: number;
        height: number;
    }

    function clickCanvas(e: MouseEvent): void {
        // The following variables are assumed to be defined elsewhere in your component or file.
        // Add them to your component's state or context as needed.
        // For demonstration, their types are shown here:
        // let sampleRectX: number, sampleRectY: number, sampleRectW: number, sampleRectH: number;
        // let lose: boolean, playAgain: boolean;

        var xPosition: number = e.clientX;
        var percentPos = (xPosition - (waveformRef.current?.offsetLeft ?? 0)) / (waveformRef.current?.offsetWidth ?? 0)
        console.log(percentPos);
        if(audio.current) {
            audio.current.currentTime = percentPos * (audio.current.duration || 0);
        }
        calculateWaveform();
    };

    function createAudio() {
        audio.current = new Audio();
        var sMP3 = document.createElement('source');
        sMP3.src = props.src;
        sMP3.type = 'audio/mpeg';
        audio.current.appendChild(sMP3);

    }

    async function toggleAudio() {
        if(!audio.current) {
            createAudio();
        }
        if(audio.current) {
            if(playing) {
                audio.current.removeEventListener("timeupdate", calculateWaveform);
                audio.current.pause();
            } else {
                audio.current.addEventListener("timeupdate", calculateWaveform);
                audio.current.play();
            }
            setPlaying(!playing);
        }

    }

    return <div className="custom-audio-player">
        <div className="play-button" onClick={toggleAudio}>
            {playing ? <PauseIcon/> : <PlayIcon/>}
        </div>
        <canvas className="waveform" ref={waveformRef}/>
        <a>{time}</a>
    </div>

}